import gettext from '@sdk/lang/gettext';
import { SingleAttachmentPreview } from '@sdk/attachments/components/SingleAttachmentPreview';
import { hasPreview } from '@sdk/attachments/helpers/utils';

import { useNavigateToMessageAction } from '@web/conversations/Conversation/ConversationProvider/hooks/useNavigateToMessageAction';
import { MessageContent } from '@web/conversations/Message/MessageContent/MessageContent';
import { MessageInfoText } from '@web/conversations/Message/MessageLayout/MessageLayout';
import { MessagePost } from '@web/conversations/types/Message';

import { usePreviewMask } from './messagePreview.hooks';
import {
  Author,
  AttachmentsContainer,
  ContentWrapper,
  Inner,
  Wrapper,
} from './messagePreview.styles';

type Props = {
  message: MessagePost;
};

export const MessagePreview = ({ message }: Props) => {
  const { navigateToMessageId } = useNavigateToMessageAction();
  const { maskEnabled, ref } = usePreviewMask();

  return (
    <Wrapper onClick={() => navigateToMessageId(message.id)}>
      <Author>{message.author.fullname}</Author>

      <Inner maskEnabled={maskEnabled}>
        <ContentWrapper ref={ref}>
          {message.isDeleted ? (
            <MessageInfoText>{gettext('message removed')}</MessageInfoText>
          ) : (
            <MessageContent content={message.content} previewMode />
          )}
        </ContentWrapper>

        <AttachmentsContainer>
          {message.attachments
            .filter((a) => hasPreview(a.mimetype, a.url))
            .map((attachment) => (
              <SingleAttachmentPreview key={attachment.id} attachment={attachment} />
            ))}
        </AttachmentsContainer>
      </Inner>
    </Wrapper>
  );
};
